import { Reveal } from "./Reveal";

const QUOTES = [
  {
    quote:
      "Everything was verified before I travelled — the contract, the employer, the accommodation. I felt safe every step of the way.",
    name: "Marko P.",
    role: "Construction Worker · Serbia → Germany",
    img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NjY5NTc5Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "They explained the work permit and the salary clearly, in writing. No pressure, no vague WhatsApp promises. A real, professional process.",
    name: "Elena R.",
    role: "Housekeeping · Romania → Spain",
    img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NjY5NTc5Mnww&ixlib=rb-4.1.0&q=85",
  },
];

export const Testimonials = () => (
  <section
    id="voices"
    data-testid="testimonials-section"
    className="py-24 md:py-32 px-6 md:px-12"
  >
    <div className="max-w-[1600px] mx-auto">
      <Reveal>
        <p className="font-body text-sm tracking-[0.25em] uppercase text-[#ff3b30] mb-16 md:mb-24">
          Candidate voices
        </p>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
        {QUOTES.map((q, i) => (
          <Reveal key={q.name} delay={i * 0.12}>
            <figure data-testid={`testimonial-${i}`} className="flex flex-col h-full">
              <blockquote className="font-accent italic text-2xl md:text-4xl leading-snug text-[#0a0a0a] mb-10">
                <span className="text-[#ff3b30] not-italic">“</span>
                {q.quote}
                <span className="text-[#ff3b30] not-italic">”</span>
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-8 border-t border-[#e4e4e7]">
                <img src={q.img} alt={q.name} className="w-14 h-14 object-cover img-grayscale" />
                <div>
                  <div className="font-head uppercase tracking-tight text-lg">{q.name}</div>
                  <div className="font-body text-sm text-[#52525b]">{q.role}</div>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
      <Reveal>
        <p className="font-body text-xs text-[#a1a1aa] mt-12">
          Representative candidate experiences. Names shortened for privacy.
        </p>
      </Reveal>
    </div>
  </section>
);
